import type { ReactNode } from "react";
import { Modal } from "@circle-react-uikit/ModalV2";
import type {
  ModalDrawerPositionType,
  ModalSizeType,
} from "@circle-react-uikit/ModalV2/ModalDrawerContent";

export interface DrawerProps {
  children?: ReactNode;
  className?: string;
  contentPortalId?: string;
  isOpen?: boolean;
  onClose: () => void;
  position?: ModalDrawerPositionType;
  shouldCloseOnOutsideClick?: boolean;
  size?: ModalSizeType;
}

export const DrawerComponent = ({
  children,
  className,
  contentPortalId,
  isOpen = false,
  onClose,
  position = "right",
  shouldCloseOnOutsideClick = true,
  size = "md",
}: DrawerProps) => (
  <Modal isOpen={isOpen} onClose={onClose} contentPortalId={contentPortalId}>
    <Modal.Overlay />
    <Modal.DrawerContent
      className={className}
      drawerPosition={position}
      size={size}
      shouldCloseOnOutsideClick={shouldCloseOnOutsideClick}
    >
      {children}
    </Modal.DrawerContent>
  </Modal>
);

export const Drawer = Object.assign(DrawerComponent, {
  Header: Modal.Header,
  Body: Modal.Body,
  Footer: Modal.Footer,
  Title: Modal.Title,
  CloseButton: Modal.CloseButton,
});
